import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-date",
  "use": "rt-base-date-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-date\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 188H740v-55.3c0-18-14.7-33.1-32.7-32.7-17.4 0.4-31.3 14.5-31.3 32v56H348v-55.3c0-18-14.7-33.1-32.7-32.7-17.4 0.4-31.3 14.5-31.3 32v56H128c-35.2 0-64 28.8-64 64v608c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V252c0-35.2-28.8-64-64-64z m-8 632c0 17.7-14.3 32-32 32H168c-17.7 0-32-14.3-32-32V292c0-17.7 14.3-32 32-32h116v15.3c0 18 14.7 33.1 32.7 32.7 17.4-0.4 31.3-14.5 31.3-32v-16h328v15.3c0 18 14.7 33.1 32.7 32.7 17.4-0.4 31.3-14.5 31.3-32v-16h116c17.7 0 32 14.3 32 32v528z\" p-id=\"2195\" /><path d=\"M704 432H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32zM704 656H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z\" p-id=\"2196\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/date.svg
// module id = 1206
// module chunks = 96